export const ServerConfig = () => {
  if (process.env.NODE_ENV === 'production') {
    return {
      dataServer: {
        sameServer: true,
        protocol: 'https',
        //host: 'gamma.dextroute.com',
        host: 'www.cscdna.com',
        port: '61017' // turn it on to verify/troubleshoot production build
      },
      logging: false
    }
  } else {
    return {
      dataServer: {
        sameServer: true,
        protocol: 'http',
        host: 'ezdev.cscdna.com',
        port: '61018'
      },
      logging: false
    }
    // return {
    //   dataServer: {
    //     sameServer: false,
    //     protocol: 'http',
    //     host: 'gamma.dextroute.com',
    //     port: '8080' // turn it on to verify/troubleshoot production build
    //   },
    //   logging: true
    // }
  }
}

export const GeneralData = {
  info: {
    version: '3.10.5',
    productName: 'EZRquest',
    productURL: 'https://ezrequest.cscdna.com'
  },

  sideBar: {
    logoText: 'Gamma NA',
    badgeTimer: process.env.NODE_ENV === 'production' ? 600000 : 120000,
    notes: 'This could be overriden if users company has a brandname property set'
  },

  methodsOfPayment: ['Cheque', 'Wire', 'Credit Card'],
  currency: ['CAD', 'USD', 'EUR', 'CNY'],
  typeOfTimeoff: ['Vacation', 'Personal', 'Sick/Dr. Appt'],
  position: [{ name: 'CEO' }, { name: 'CFO' }, { name: 'CTO' }, { name: 'COO' }, { name: 'CDO' }, { name: 'CSO' }],
  country: [
    {
      name: 'USA',
      currency: 'USD'
    },
    {
      name: 'Canada',
      currency: 'CAD'
    }
  ],
  userRoles: [
    { id: 0, name: 'Super Admin' },
    { id: 1, name: 'Company Admin' },
    { id: 2, name: 'Regular User' },
    { id: 99, name: 'Guest' }
  ]
}
/*
  Optional configuration, will only take effect when explicitly configured, otherwise they all should have default values
*/
export const GAT = {
  input: {
    payToLength: 50
  }
}
/*
  Not currently used
*/
export const subContractPayment = {
  input: {
    invoiceNumberLength: 20,
    invoiceNumberMaxValue: 120,
    subContractChangeMaxValue: 99999999,
    taxRateMaxValue: 70,
    table: {
      header: ['No.', 'Description', 'Pay to Date', 'Current Payment', 'Total Accumulated'],
      rows: ['Contract Works', 'Additional Works', ' 10% Hold Back', 'Advanced Payment', 'GST/HST'],
      singers: ['Procurement', 'CCD', 'CFO', 'Senior VP', 'Chairman', 'Subsidiary/Branch Office']
    }
  }
}

export const UserEnum = {
  SUPER: 0,
  ADMIN: 1,
  USER: 2,
  EXPENSE_RECEIVER: 97,
  PROCUREMENT_RECEIVER: 98,
  GUEST: 99
}
